module.exports = __webpack_public_path__ + "img/login-illustrations.5f7e60e9.svg";